import { render, staticRenderFns } from "./AscFeatureFlagsTemplate.vue?vue&type=template&id=21ef6138&"
import script from "./AscFeatureFlagsTemplate.vue?vue&type=script&lang=js&"
export * from "./AscFeatureFlagsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports